// features/ui/uiSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hideBottomNav: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHideBottomNav: (state, action) => {
      state.hideBottomNav = action.payload;
    },
  },
});

export const { setHideBottomNav } = uiSlice.actions;
export default uiSlice.reducer;